(ns ycweb.app.admin.buying.rangereview.digitalreview
  (:require
   [rum.core :as rum]
   [ycweb.app.admin.buying.rangereview.common :as rangecmn]
   [ycweb.app.website.cards :as awc]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.grid :as grid]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.headings :as headings]
   [ycweb.components.forms :as forms]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))

(rum/defc review-line-item < rum/reactive [app-atom item]
  (let [process-atom (cmn/process-cursor app-atom)
        card-details? (cmn/curact process-atom :card-details)
        large-text? (cmn/curact process-atom :large-text)]
    [:td.grid-column.u-print-td
     (awc/trend-card app-atom item card-details? large-text?)]))

(rum/defc review-line < rum/reactive [app-atom group-items]
  [:tr.u-display-contents.u-print-tr
   (list
     (concat
       (map (partial review-line-item app-atom) group-items)
       (repeat (- 4 (count group-items)) [:td.grid-column.u-print-td ""])))])

(rum/defc rangereview-review-products < rum/reactive cmn/cursors [app-atom]
  (let [action-atom (cmn/action-cursor app-atom)
        {:category/keys [status] :as category} (cmn/curact action-atom [:category])
        range-review (cmn/curact action-atom [:range-review])
        process-atom (cmn/process-cursor app-atom)
        card-sort (cmn/curact process-atom :card-sort-value)
        comp-price-variation-fn (comp :variation/price :item-line/variation)
        brand-filter (cmn/curact action-atom [:brand-filter])
        current-cat-uuid (:ent/uuid category)

        next-category
        (->>
          (:admin.rangereview/category @app-atom)
          :sub-categories
          (vals)
          (sort-by :ent/display-name)
          (sort-by :category/total-income)
          (drop-while #(not= current-cat-uuid (:ent/uuid %)))
          (second))

        next-button-config
        (cond
          next-category
          {:icon :arrow-right
           :display-text "Next"}

          :else
          {:icon :success
           :display-text "Finish Review"})

        selected-brands
        (when (not (nil? brand-filter))
          (keys (filter second brand-filter)))

        variation-list
        (cond
          selected-brands
          (filter
            #(contains? (set selected-brands) (get-in % [:item-line/product :product/brand-name]))
            (vals (cmn/curact action-atom [:variations])))

          :else
          (vals (cmn/curact action-atom [:variations])))

        sort-fn
        (cond
          (= card-sort "price")
          (juxt (comp :variation/price :item-line/variation) comp-price-variation-fn)

          :else
          (juxt (comp :variation/total-income-for-period :item-line/variation) comp-price-variation-fn))

        variations
        (->>
          variation-list
          (sort-by sort-fn u/desc)
          (partition-all 4))

        large-card? (cmn/curact process-atom :large-card)
        large-text? (cmn/curact process-atom :large-text)]

    [:div.admin-react-wrapper__content
     (rangecmn/rangereview-header app-atom :digital large-text?)
     [:div
      {:class
       (u/bem :flex-grid-group [:valign-bottom :flush-force :align-left])}
      [:div
       {:class (u/bem :flex-grid-block [:fluid])}
       [:div.flex-grid-content
        [:div.form-field
         [:label.form-label "Filter by brand:"]
         (buttons/button-web
           "All brands"
           {:style :secondary
            :size :default
            :icon :chevron-down
            :icon-placement :right
            :on-click #(grid/open-modal app-atom :rangereview/brand-filter {})})]]]
      [:div
       {:class (u/bem :flex-grid-block [:fluid])}
       [:div.flex-grid-content
        [:div.form-field
         [:label.form-label "Sort by: (descending)"]
         (forms/select-raw
           (rum/cursor-in process-atom [:card-sort-value])
           [{:value "income" :text "Income"}
            {:value "price" :text "Price point"}]
           {:sort? true
            :id "card-sorting"})]]]
      [:div
       {:class (u/bem :flex-grid-block [:fluid])}
       [:div.flex-grid-content
        [:div.form-field
         (buttons/button-web
           [:span.u-hidden-from-view "Display more"]
           {:style :secondary
            :size :default
            :icon  (if large-card? :grid-small :grid-default)
            :icon-only true
            :on-click
            #(swap!
               (cmn/process-cursor app-atom)
               assoc
               :large-card
               (if (= (:large-card @(cmn/process-cursor app-atom)) true)
                 false
                 true))})]]]
      [:div
       {:class (u/bem :flex-grid-block [:align-right :fluid])}
       [:div.flex-grid-content
        [:div.form-field
         (forms/toggle
           "Card details"
           (rum/cursor process-atom :card-details)
           {:id "toggle-card-details"
            :name "card-details"})
         (forms/toggle
           "Large display text"
           (rum/cursor process-atom :large-text)
           {:id "toggle-large-text"
            :name "large-text"})]]]]

     [:table.u-display-block.u-margin-bottom-40
      [:tbody
       {:class
        (u/bem
          :grid
          [(if large-card? :xl-1-5 :xl-1-8) :l-1-4 :m-1-3 :t-1-2])}
       (map (partial review-line app-atom) variations)]]
     [:div.admin-action-bar
      [:div
       {:class
        (u/bem
          :flex-grid-group
          [:row-reversed :align-between :valign-middle :flush])}
       [:div.u-min-width-240
        {:class (u/bem :flex-grid-block [:fluid :flush])}
        [:div.flex-grid-content
         [:div
          {:class
           (u/bem :flex-grid-group [:row-reversed :valign-middle :flush])}
          [:div.u-min-width-240
           {:class (u/bem :flex-grid-block [:fluid])}
           [:div.flex-grid-content
            (buttons/button-web
              (:display-text next-button-config)
              {:style :primary
               :size :default
               :full true
               :icon (:icon next-button-config)
               :icon-placement :right
               :on-click
               #(grid/dispatch-action app-atom :admin.rangereview/next-category
                  {:review-uuid (:ent/uuid range-review)
                   :category-uuid (:ent/uuid next-category)})})]]
          [:div.u-min-width-240
           {:class (u/bem :flex-grid-block [:fluid])}
           (buttons/button-web
             (if (and status (= status :range-review-constraint.status/complete))
               "Mark as Draft"
               "Mark as Complete")
             {:style :secondary
              :size :default
              :on-click
              #(grid/dispatch-action app-atom :admin.rangereview/update-print-category-status
                 {:category-uuid (:ent/uuid category)
                  :review-uuid (:ent/uuid range-review)
                  :new-status
                  (if (and status (= status :range-review-constraint.status/complete))
                    :range-review-constraint.status/draft
                    :range-review-constraint.status/complete)})
              :full true
              :icon :success})]]]]

       [:div.u-min-width-240
        {:class (u/bem :flex-grid-block [:fluid :flush])}
        [:div.flex-grid-content
         (buttons/button-web "Back"
           (merge
             (urlstate/href-props app-atom "rangereview" "select-products" {:review-uuid (:ent/uuid range-review) :category-uuid (:ent/uuid category)})
             {:style :secondary
              :size :default
              :full true
              :icon :arrow-left}))]]]]
     (toaster/loading-overlay app-atom :admin.rangereview/print-review)]))

(defmethod grid/action :admin.rangereview/update-print-category-status [app-atom config _]
  (grid/open-modal app-atom :rangereview/complete-cat)
  (let [category-atom (rum/cursor-in (cmn/action-cursor app-atom) [:category])]
    (swap! category-atom assoc
      :category/status (:new-status config)))
  (comms/send :admin.rangereview/update-category-status config)
  (grid/open-modal app-atom :rangereview/complete-cat))

(defmethod flow/render-screen :admin.rangereview/digital [app-atom _]
  (rangereview-review-products app-atom))

(defmethod t/transition-open :admin.rangereview/digital [app-atom _ params]
  (toaster/open-overlay app-atom :admin.rangereview/print-review)
  (swap! (cmn/action-cursor app-atom) assoc
    :review-uuid (:review-uuid params)
    :category-uuid (:category-uuid params)
    :variations nil)
  (swap! (cmn/process-cursor app-atom) assoc
    :card-sort "income"
    :large-card true
    :card-details true
    :large-text false)
  (comms/send :admin.rangereview/print-products
    (assoc params
      :view-products :all
      :with-history? true
      :included-only? true)))

(rum/defc product-added-modal-body < rum/reactive [app-atom]
  [:p.yc-paragraph
   "Category status updated"])

(rum/defc product-added-modal-footer < rum/reactive [app-atom]
  (let [action-atom (cmn/action-cursor app-atom)
        {:category/keys [status] :as category} (cmn/curact action-atom [:category])
        range-review (cmn/curact action-atom [:range-review])]
    [:div
     (grid/button-row
       {:left-text "Stay here"
        :left-fn #(grid/close-modal app-atom)
        :left-no-icon true
        :right-text "Back to categories"
        :right-fn #(urlstate/redirect app-atom "rangereview" "category" {:review-uuid (:ent/uuid range-review) :category-uuid (:category/prev-level category)})
        :right-no-icon true})]))

(defmethod grid/action :admin.rangereview/close-complete-cat [app-atom config _]
  (grid/close-modal app-atom))

(defmethod grid/modal-config :rangereview/complete-cat [_ _ _]
  {:body product-added-modal-body
   :footer product-added-modal-footer
   :cancel-key :admin.rangereview/close-complete-cat
   :modal-type :variable
   :max-width 480})

(rum/defc brand-filter-modal-body < rum/reactive [app-atom]
  (let [action-atom (cmn/action-cursor app-atom)
        brand-filter-atom (rum/cursor-in action-atom [:brand-filter])

        brands
        (->>
          (cmn/curact action-atom [:variations])
          (vals)
          (map #(get-in % [:item-line/product :product/brand-name])))]
    [:<>
     (headings/heading "Filter by brand" {:type :h2 :size :default})
     (map
       (fn [[brand-name brand-count]]
         [:div.form-field
          (forms/checkbox (str brand-name " (" brand-count ")") (rum/cursor brand-filter-atom brand-name) {})])
       (sort (frequencies brands)))]))

(rum/defc brand-filter-modal-footer < rum/reactive [app-atom]
  [:div
   (grid/button-row
     {:left-text "Close"
      :left-fn #(grid/close-modal app-atom)
      :left-no-icon true
      :right-text "Filter"
      :right-fn #(grid/close-modal app-atom)
      :right-no-icon true})])

(defmethod grid/modal-config :rangereview/brand-filter [_ _ _]
  {:body brand-filter-modal-body
   :footer brand-filter-modal-footer
   :modal-type :standard
   :max-width 480})

(defmethod grid/action :admin.rangereview/next-category [app-atom config _]
  (cond
    (nil? (:category-uuid config))
    (urlstate/redirect app-atom "rangereview" "category"
      {:review-uuid (:review-uuid config)})

    :else
    (urlstate/redirect app-atom "rangereview" "digital"
      {:review-uuid (:review-uuid config)
       :category-uuid (:category-uuid config)})))

